import React from 'react'
import { Container, TabName } from './HomeTabs.style'
import { useTranslation } from 'react-i18next'

interface Props {
    onTabChange: (tab: number) => void
    activeTab: number
}

const HomeTabs: React.FC<Props> = ({ activeTab, onTabChange }) => {
    const { t } = useTranslation()

    return (
        <Container>
            <TabName $active={activeTab === 0} onClick={() => onTabChange(0)}>
                {t('home.actual')}
            </TabName>
            <TabName $active={activeTab === 1} onClick={() => onTabChange(1)}>
                {t('home.past')}
            </TabName>
        </Container>
    )
}

export default HomeTabs
